import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class TextH3 extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path d="M2.2,3.2h1v3.3h3.7V3.2h1V11h-1V7.3H3.2V11h-1V3.2z" />
          <path
            d="M9.7,9.5c0.2,0.2,0.5,0.5,0.8,0.6c0.3,0.2,0.7,0.3,1.1,0.3c0.5,0,0.8-0.1,1.1-0.4c0.3-0.3,0.4-0.6,0.4-1
					c0-0.2,0-0.4-0.1-0.6S12.9,8,12.7,7.9c-0.2-0.1-0.4-0.2-0.8-0.3c-0.3-0.1-0.7-0.1-1.2-0.1V6.7c0.4,0,0.8,0,1-0.1
					c0.3-0.1,0.5-0.2,0.7-0.3c0.2-0.1,0.3-0.3,0.4-0.5C13,5.6,13,5.5,13,5.3c0-0.4-0.1-0.7-0.4-0.9c-0.2-0.2-0.6-0.3-1-0.3
					c-0.3,0-0.6,0.1-0.9,0.2c-0.3,0.1-0.5,0.3-0.8,0.6L9.5,4.2c0.3-0.3,0.6-0.5,1-0.7c0.4-0.2,0.8-0.3,1.2-0.3c0.3,0,0.6,0,0.9,0.1
					c0.3,0.1,0.5,0.2,0.7,0.4c0.2,0.2,0.4,0.4,0.5,0.6C14,4.6,14,4.9,14,5.2c0,0.5-0.1,0.8-0.4,1.1S13,6.9,12.6,7v0
					c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0.1,0.4,0.2,0.5,0.4c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.1,0.5,0.1,0.7c0,0.3-0.1,0.6-0.2,0.9
					c-0.1,0.3-0.3,0.5-0.5,0.7c-0.2,0.2-0.5,0.3-0.8,0.4c-0.3,0.1-0.6,0.1-1,0.1c-0.3,0-0.6,0-0.8-0.1c-0.3-0.1-0.5-0.1-0.7-0.2
					c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.3-0.3-0.4-0.4L9.7,9.5z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/TextH3.js